export function ScoreGauge({ label, value, emoji, testId }) {
  const status = value >= 80 ? "success" : value >= 60 ? "warning" : "error";
  const color = status === "success" ? "#0F7B0F" : status === "warning" ? "#D9730D" : "#E03E3E";
  const bgClass = status === "success" ? "callout-green" : status === "warning" ? "callout-orange" : "callout-red";
  const statusLabel = status === "success" ? "Excellent" : status === "warning" ? "Needs work" : "Critical";

  return (
    <div className="border border-[#EBEBEA] rounded-lg p-6 bg-white" data-testid={testId}>
      <div className="flex items-center gap-3 mb-6">
        <span className={`notion-emoji-box ${bgClass}`}>{emoji}</span>
        <div>
          <div className="text-sm font-medium text-[#37352F]">{label}</div>
          <div className="text-xs text-[#787774]">{statusLabel}</div>
        </div>
      </div>

      <div className="flex items-baseline gap-2 mb-4">
        <span className="text-5xl font-bold tracking-tight text-[#37352F]" data-testid={`${testId}-value`}>
          {value}
        </span>
        <span className="text-lg text-[#9B9A97]">/ 100</span>
      </div>

      <div className="h-2 bg-[#F1F1EF] rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${value}%`, background: color }}
        />
      </div>
    </div>
  );
}
